export default __webpack_public_path__ + "img/tab1and2_nav5-1-b408ee67.png";